export const enum ChargeType {
  DirectCharge = 'direct_charge',
  RecurrentCharge = 'recurrent_charge',
}

export const enum BillingCycles {
  Monthly = 1,
  Yearly = 12,
}
